export default {
  card: {},
  list: [],
  pageCount: 0
}



// WEBPACK FOOTER //
// ./src/features/admin/astroPay/store/state.js